import { render, staticRenderFns } from "./GeneralTenantFileImage.vue?vue&type=template&id=07501d31"
import script from "./GeneralTenantFileImage.vue?vue&type=script&lang=js"
export * from "./GeneralTenantFileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports